// General
import { ready } from './lib/ready'

// Stimulus.js and controllers
import { Application } from 'stimulus';
import ExpandableController from './lib/expandable';

// Setup functions
import { InView } from './lib/in-view';
import { AnchorScrollTo } from './lib/anchor-scroll-to';
import { SetupSwiper } from './lib/setup-swiper';
import { metric } from './lib/metric';

ready(function () {

  // var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  // if (isIE11) document.body.classList.add("-is-ie-11");

  // // Stimulus.js and controllers
  // const application = Application.start();
  // application.register('expandable', ExpandableController);

  // // Setup functions
  // InView();
  // AnchorScrollTo();
  // SetupSwiper();
  metric();

});